<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <div id="loader" class="loader">
      <div class="loader__bg--init"></div>
      <canvas class="loader__bg"></canvas>
      <div class="loader__logo">
        <div class="loader__logo_video">
          <video webkit-playsinline autoplay playsinline muted loop>
            <source type="video/mp4;" src="/videos/Loader-en.mp4">
          </video>
        </div>

        <div class="loader__logo_title">
          {{$t('loadText')}}
        </div>
      </div>
    </div>
    <Header ref="header" />
<!--    <div class="code" v-if="showCode">-->
<!--        <img src="/images/code.jpg" alt="">-->
<!--        <div class="line" @click="closeCode">-->
<!--          <span>-->
<!--            <i class="el-icon-plus"></i>-->
<!--          </span>-->
<!--        </div>-->
<!--    </div>-->

    <div id="wrap">
      <div class="scroll-wrapper">
        <router-view />

        <Footer @trigger-lang="triggerLang" />
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import ck from '@/oceanSchool/ck.js'
  import resize from '@/oceanSchool/resize.js'
  import runs from '@/oceanSchool/runs.js'
  import scroll from '@/oceanSchool/scroll.js'
  import runu from '@/oceanSchool/runu.js'
  import runl from '@/oceanSchool/runl.js'
  import Loader from '@/util/loader.js'

  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'

  export default {
    components: {
      Header,
      Footer
    },
    data(){
      return {
        showCode:false,
        loader:'',
        loading:false
      }
    },
    mounted () {
      ck.default.check({
        gpu: true
      })
      resize.default.start()
      runs.default.start()
      scroll.start({
        speed: 0.9,
        damping: 0.1
      })
      runu.default.start()
      runl.default.start()
      this.loader = new Loader();
      this.load(1)
      setTimeout(()=>{
        this.showCode=true
      },2500)
    },
    watch: {
      '$route':'load'
    },
    methods: {
      closeCode(){
        this.showCode=false
      },
      triggerLang () {
        this.$refs.header.$refs.langbox.triggerBtn()
      },
      load(val){
        const time=this.$route.name=='home'&&val==1?1500:300
        if(!this.loading){
          this.loader.display()
          this.loading=true
          setTimeout(() => {
            this.loader.hide()
            this.loading=false
          }, time)
        }
      }
    }
  }
</script>
<style>
  /*.svg {*/
  /*  display: none;*/
  /*}*/
  a,img,button,input,textarea,div{-webkit-tap-highlight-color:rgba(255,255,255,0);}
.code{
  position: fixed;
  right:5px;
  top:400px;
  z-index: 5000;
  padding: 0 40px;
  cursor: pointer;
  transition: all 600ms;
  transform: translateX(40px);
}
  .code:hover{
    transform: translateX(0);
  }
  .code .line{
    position: absolute;
    right:5px;
    top:0;
  }
  .code .line span{
    display: inline-block;
    transition: all 600ms;
  }
  .code .line span:hover{
    transform: rotate(45deg);
    color:white;
  }
  .code .line i{
    font-size: 25px;
    line-height:90px;
    color: #d0d0d0;
  }
  .code img{
    width:100px;
    height:100px;
    object-fit: contain;
    display: block;
    border-radius: 10px;
  }
  .loader {
    position: fixed;
    z-index: 3000;
    top: 0;
    left: 0;
    /* width: 100vw; */
    /* height: 100vh; */
    right: 0;
    bottom: 0;
    pointer-events: none;
  }

  .loader.loader--init .loader__bg--init {
    transform: scaleY(1)
  }

  .loader__bg--init {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    position: absolute;
    transform-origin: top;
    transform: scaleY(0);
  }

  .loader__bg {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .loader__logo {
    position: absolute;
    top: calc(50% - 300px * 0.5);
    left: calc(50% - 350px * 0.5);
    opacity: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    transition: opacity 0.3s linear 0.4s;
  }
  .loader__logo.loader__logo--playing {
    opacity: 1;
    transition: opacity 0.3s linear 0.4s;
  }

  .loader__logo_video {
    width: 280px;
    height: 260px;
    margin: auto;
  }

  .loader__logo_title {
    font-size: 14px;
  }
</style>
